__turbopack_context__.v({
  "callout": "xhgQwW_callout",
});
